export default "__VITE_ASSET__uqZ9rXuF__"